module.exports = __webpack_public_path__ + "static/media/need-doc-2.13177b1b.svg";